import type { VehicleRegoResponse } from '@/types/redbook-api';

const fetchVehicleByRego = async (numberPlate: string): Promise<{ data: VehicleRegoResponse }> => {
  if (!numberPlate) {
    return { data: { error: 'Number plate is required' } };
  }

  try {
    const params = new URLSearchParams({
      query: numberPlate,
    });

    const response = await fetch(`/api/lookup-vehicle-rego?${params}`);

    if (!response.ok) {
      throw new Error(`API error: ${response.status} ${response.statusText}`);
    }

    const data: VehicleRegoResponse = await response.json();

    return { data };
  } catch (error) {
    console.error('Error fetching vehicle by rego: ', error);
    return { data: { error: 'Failed to fetch vehicle data' } };
  }
};

export default fetchVehicleByRego;
